export const EXPERIENCE = [
    {
        id: 'roku',
        company: 'Roku',
        logo: '/assets/roku-logo.png',
        title: 'Senior Engineer',
        tenure: 'Jul 2026 - Present',
        skills: ['React', 'TypeScript', 'CTV', 'Video Playback', 'HLS/DASH', 'DRM', 'Ad Integration', 'Off-Platform'],
        description: 'Off-platform team building the Roku channel frontend across CTV devices and Web. Working on video playback, DRM-protected streaming, and ad integration to deliver a consistent channel experience across platforms.',
        current: true,
        url: 'https://www.roku.com/',
    },
    {
        id: 'fleek',
        company: 'Fleek',
        logo: '/assets/fleek-yellow-logo.svg',
        title: 'Tech Lead',
        tenure: 'Jun 2025 - Jun 2026',
        skills: ['React', 'React Native', 'TypeScript', 'Design System', 'Team Leadership', 'Attribution Optimization'],
        description: 'Led frontend architecture and team across 5 geolocations. Introduced Design System, increased Attribution from 5% to 35% reducing CAC and optimizing ad budget. Led high-impact features to final delivery.',
        current: false,
        url: 'https://www.joinfleek.com/home',
    },
    {
        id: 'fancode-sde3',
        company: 'FanCode',
        logo: '/assets/fancode-icon.svg',
        title: 'Software Development Engineer III',
        tenure: 'Jun 2022 - Jun 2025',
        skills: ['React', 'React Native', 'Microfrontend', 'Monorepo', 'SSR', 'Video Streaming', 'Ad Integration'],
        description: 'Introduced Microfrontend in CMS ecosystem. Led Video and Ads team delivering high-quality tasks impacting revenue. Integrated Google Ads, SSAI/CSAI ads, Cast Adapter. Implemented Redis cache for consistent SSR. Video re-architecture to speed up start time.',
        current: false,
        url: 'https://www.fancode.com/',
    },
    {
        id: 'fancode-sde2',
        company: 'FanCode',
        logo: '/assets/fancode-icon.svg',
        title: 'Software Development Engineer II',
        tenure: 'Nov 2020 - Jun 2022',
        skills: ['React', 'React Native', 'Bundle Optimization', 'SSR', 'CI/CD', 'Performance'],
        description: 'Bundle splitting and size optimization improving first load time. SSR implementation. CI/CD integration with GitHub Actions for bundle size tracking. Created Bundle Size tracker Dashboard. Redux integration improving App performance by ~150%.',
        current: false,
        url: 'https://www.fancode.com/',
    },
    {
        id: 'flipkart',
        company: 'Flipkart',
        logo: '/assets/flipkart-icon.svg',
        title: 'UI Engineer',
        tenure: 'Jun 2018 - Oct 2020',
        skills: ['React', 'React Native', 'JavaScript', 'TypeScript', 'Performance Optimization', 'CI/CD'],
        description: 'Revamped fashion experience resulting in 3.52% more user engagement. Created CI/CD pipeline for bundle size and performance metrics. Migration to React Native for Web for common codebase. Worked on Baskets Building features.',
        current: false,
        url: 'https://www.flipkart.com/',
    },
    {
        id: 'atkins',
        company: 'WS Atkins Pvt Ltd',
        logo: '/assets/atkins-icon.svg',
        title: 'SDE Intern',
        tenure: 'May 2017 - Jul 2017',
        skills: ['C#', 'Unity', 'AR/VR', '3D Modeling', 'Blender', 'HTC Vive', 'Microsoft HoloLens'],
        description: 'Designed virtual dimension measuring application in HTC Vive and AR replica for Android. Worked on 3D modeling using Blender and Maya. Compared Unity, Unreal, and Stingray engines. Created Virtual Interacting Model in Microsoft HoloLens.',
        current: false,
    },
];
